export const zIndex = {
  _1: 100,
  _2: 200,
  _3: 300,
  _302: 302,
  _4: 400,
  _5: 500,
  _10: 999,
};
